import './login.css'

import $ from 'jquery'
import get from 'lodash/get'
import includes from 'lodash/includes'
import isNil from 'lodash/isNil'
import set from 'lodash/set'

import PoziAPIData from 'api/data'
import { HistoryUpdate } from 'api/history'
import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import PoziNotifications from 'utils/notifications'

export default function PoziDrawerTabToolsLogin () {
  // Adapters
  const adapters = {
    /**
     * @api {NA} PoziDrawerTabToolsLogin().init Init
     * @apiDescription Initialise events for login
     * @apiGroup Login
     * @apiName Init
     *
     * @apiHeader (Model-On) {Function} Event app.event.drawer.tabs.tools.auth.loggedin Set to true when user login successful
     */
    init: function () {
      return init()
    }
  }

  var init = function () {
    _logoutSuccess() // Cleanup any old login stuff like add buttons if user didn't logout.

    const visible = Model.get('config.layout.drawer.tabs.tools.login.visible', false)
    const loginType = Model.get('config.layout.drawer.tabs.tools.login.type', '')

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    // ONLY DO THIS IF NOT AWS LOGIN. BASICALLY THIS IS ONLY FOR CREEKLINK.
    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    if (visible && loginType !== 'aws') {
      $('#login-div').show()
      $('#login-div').on('click', showLoginControl)
      $('#tools-login-button').on('click', loginClicked)
      $('#tools-logout-button').on('click', logoutClicked)
      const JS_CHAR_KEY_CODE_ENTER = 13
      $('#login-div-info').keypress(function (e) {
        if (e.which === JS_CHAR_KEY_CODE_ENTER) {
          loginClicked()
          return false
        }
      })

      /*
      if (window.debug.enabled) {
        console.log('!!!! AUTO LOGIN ENABLED !!!.')
        console.log('!!!! AUTO LOGIN ENABLED !!!.')
        console.log('!!!! AUTO LOGIN ENABLED !!!.')
        console.log('!!!! AUTO LOGIN ENABLED !!!.')
        $('#tools-login-text-username').val('practice')
        $('#tools-login-text-password').val('practice')
        loginClicked()
      }
      */
    }
  }

  var showLoginControl = function () {
    console.log('showLoginControl')
    $('#login-div-info').show()
    $('#manual-login').show()
    $('#tools-login-text-username').focus()
  }

  var loginClicked = function (evt) {
    console.log('loginClicked')
    _logoutSuccess() // Cleanup any old login stuff like add buttons if user didn't logout.
    const prependToUsername = Model.get('config.layout.drawer.tabs.tools.login.prependToUsername', '')
    const data = {}
    data.username = prependToUsername + $('#tools-login-text-username').val()
    Model.set('app.event.drawer.tabs.tools.auth.username', data.username)
    data.password = $('#tools-login-text-password').val()
    Model.set('app.event.drawer.tabs.tools.auth.password', data.password)
    console.log('Credentials', data)
    const url = Model.get('config.layout.drawer.tabs.tools.login.url', '')
    if (url === '') {
      return _loginFailed()
    }
    _sendRequest(data, url)
      .then(function (data) {
        console.log('Login response', data) // Returns html of logged in page. Or invalid login html page.
        if (includes(data, 'Invalid username/password combination.')) {
          return _loginFailed()
        } else {
          return _loginSuccess()
        }
      })
      .catch(function (err) {
        console.log('Auth error', err)
        return _loginFailed()
      })
  }

  var logoutClicked = function (evt) {
    console.log('Logout - Removes session cookie JSESSIONID by attempting invalid login.')
    const data = {}
    data.username = ''
    data.password = ''
    const url = Model.get('config.layout.drawer.tabs.tools.login.url', '')
    if (url === '') {
      return _logoutFailed()
    }
    _sendRequest(data, url)
      .then(function (data) {
        console.log('Login response', data) // Returns html of logged in page. Or invalid login html page.
        if (includes(data, 'Invalid username/password combination.')) {
          return _logoutSuccess()
        } else {
          return _logoutFailed()
        }
      })
      .catch(function (err) {
        const responseText = get(err, 'responseText', '')
        console.log('Auth error', responseText)
        if (includes(responseText, 'requires HTTP authentication')) {
          return _logoutSuccess()
        } else {
          return _logoutFailed()
        }
      })
  }

  var _sendRequest = function (data, url) {
    return new Promise(function (resolve, reject) {
      PoziAPIData().ajax({
        dataType: 'text',
        method: 'POST',
        timeout: 10000,
        cache: false,
        headers: {
          'x-pozi-allow-credentials': '',
          'x-pozi-single-origin': ''
        },
        xhrFields: {
          withCredentials: true
        },
        data,
        url,
        error: reject,
        success: resolve
      })
    })
  }

  var _loginSuccess = function () {
    Model.set('app.event.drawer.tabs.tools.auth.loggedin', true)
    _notify('Login success', true)

    console.log('Turn on user linkedlayers')
    const username = Model.get('app.event.drawer.tabs.tools.auth.username', null)
    if (isNil(username)) {
      return
    }
    const user = _findUser(username)
    if (isNil(user)) {
      return
    }
    const linkedLayers = get(user, 'linkedLayers', [])
    if (linkedLayers.length > 0) {
      for (const key in linkedLayers) {
        const linkedLayer = linkedLayers[key]
        const linkedLayerTitle = get(linkedLayer, 'title', '')
        const linkedLayerEnable = get(linkedLayer, 'enable', true)
        const linkedLayerShowInLayerControl = get(linkedLayer, 'showInLayerControl', true)
        const layer = PoziUtils.getLayerFromTitle(linkedLayerTitle)
        const titleid = layer.titleid
        if (isNil(layer)) {
          console.log('_loginSuccess: Invalid layer.')
          return
        }
        set(layer, 'showInLayerControl', linkedLayerShowInLayerControl)
        set(layer, 'drawer.visible', linkedLayerShowInLayerControl)
        if (linkedLayerShowInLayerControl) {
          $('.pozi-drawer-layer-' + titleid).removeClass('hidden')
        } else {
          $('.pozi-drawer-layer-' + titleid).addClass('hidden')
        }
        if (linkedLayerEnable) {
          PoziUtils.turnLayerOn(titleid)
        } else {
          PoziUtils.turnLayerOff(titleid)
        }
      }
      HistoryUpdate()
    }
  }

  var _findUser = function (username) {
    const users = Model.get('config.users', null)
    for (const key in users) {
      const user = users[key]
      const usernameFind = get(user, 'username', '')
      if (usernameFind === username) {
        return user
      }
    }
    return null
  }

  var _loginFailed = function () {
    Model.unset('app.event.drawer.tabs.tools.auth.loggedin')
    Model.unset('app.event.drawer.tabs.tools.auth.username')
    Model.unset('app.event.drawer.tabs.tools.auth.password')
    _notify('Login failed', false)
  }

  var _logoutSuccess = function () {
    console.log('_logoutSuccess')

    console.log('Turn off user linkedlayers')
    const username = Model.get('app.event.drawer.tabs.tools.auth.username', null)
    if (isNil(username)) {
      return
    }
    const user = _findUser(username)
    if (isNil(user)) {
      return
    }
    const linkedLayers = get(user, 'linkedLayers', [])
    if (linkedLayers.length > 0) {
      for (const key in linkedLayers) {
        const linkedLayer = linkedLayers[key]
        const linkedLayerTitle = get(linkedLayer, 'title', '')
        const layer = PoziUtils.getLayerFromTitle(linkedLayerTitle)
        const titleid = layer.titleid
        if (isNil(layer)) {
          console.log('_logoutSuccess: Invalid layer.')
          return
        }
        set(layer, 'showInLayerControl', false)
        set(layer, 'drawer.visible', false)
        $('.pozi-drawer-layer-' + titleid).addClass('hidden')
        PoziUtils.turnLayerOff(titleid)
      }
      HistoryUpdate()
    }

    Model.unset('app.event.drawer.tabs.tools.auth.loggedin')
    Model.unset('app.event.drawer.tabs.tools.auth.username')
    Model.unset('app.event.drawer.tabs.tools.auth.password')
    _notify('Logout success', true)
  }

  var _logoutFailed = function () {
    Model.unset('app.event.drawer.tabs.tools.auth.loggedin')
    Model.unset('app.event.drawer.tabs.tools.auth.username')
    Model.unset('app.event.drawer.tabs.tools.auth.password')
    _notify('Logout failed', false)
  }

  var _notify = function (msg, bSuccess) {
    if (bSuccess) {
      $('#tools-login-feedback').text(msg)
      PoziNotifications().notify(msg)
    } else {
      $('#tools-login-feedback').text(msg)
      PoziNotifications().warning(msg)
    }
    PoziUtils.showElementThenHideAfterAFewSeconds('#tools-login-feedback')
  }

  // Return adapters (must be at end of adapter)
  return adapters
}
